import React from 'react';
import { StyleSheet, View, Text, ViewStyle } from 'react-native';

import colors from 'shared/modules/common/constants/colors';
import typography from 'shared/modules/common/constants/typography';

type Props = {
  title: string;
  description: string;
  note?: string;
  containerStyle?: ViewStyle;
};

export default function DescriptionItem({ title, description, note }: Props) {
  return (
    <View style={styles.border}>
      <View style={styles.container}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.description}>{description}</Text>
      </View>
      {note && <Text style={styles.note}>{note}</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  border: {
    borderBottomWidth: 1,
    borderBottomColor: colors.greyLight,
    paddingVertical: 16,
  },
  title: {
    ...typography.caption02,
    fontWeight: '700',
    color: colors.blackMedium,
  },
  description: {
    flexShrink: 1,
    ...typography.caption02,
    color: colors.teal,
    fontWeight: '400',
    textAlign: 'right',
    flexWrap: 'wrap',
  },
  note: {
    ...typography.caption02,
    color: '#101825',
    fontWeight: '400',
    marginTop: 16,
  },
});
